import { ConvertService } from "./ConvertService";
import { ParsedNameValue } from "./ParsedNameValue";

export class ObjectService extends ConvertService
{
    static isClass(obj: any)
    {
        return typeof obj === 'function' && /^\s*class\s+/.test(obj.toString());
    }
    private object: ParsedNameValue;
    constructor(object: ParsedNameValue, mandatory: boolean = false)
    {
        super(mandatory);
        this.object = object;
    }
    override getNullString()
    {
        let ans: string | null = null;
        if (Array.isArray(this.object))
        {
            if (this.object.length > 0)
                ans = this.object.join(",");
        }
        else if (this.object != null && this.object != undefined)
            ans = this.object + "";
        return ans;
    }
}